/**
 * Created by wdzxc on 2016/5/7.
 */

// dependence
import {objCover} from "../../utils/objectOpt";

// iFrame标记
let count = 0;
let shelterList = [];
let sessionCodeInc = 0;

// 跨域Ajax
function AjaxAgency(config) {

    // 基础配置信息
    let options = {
        crossOriginSrc: "spy.html",
        ajaxOptions: {
            success: null,
            error: null
        }
    };
    objCover(options, config);

    let shelterName = null;
    let shelter = {};
    let sessionCode = sessionCodeInc++;

    function parseMsg(str) {
        let obj = JSON.parse(str);
        if (obj.msgOrigin == "spy") return obj;
        return obj;
    }

    function sendMsg(msgType, msgData) {
        let msg = {};
        msg.msgOrigin = "contact";
        msg.type = msgType;
        msg.data = msgData;
        msg.shelterName = shelterName + sessionCode;
        window[shelterName].postMessage(JSON.stringify(msg), '*');
    }

    function transfer(msgType, msgData) {
        let count = 0;
        let timer = setInterval(function () {
            count++;
            if (shelter.isSpyReady) {
                sendMsg(msgType, msgData);
                clearInterval(timer);
                return;
            }
            if (count > 30) {
                console.log("代理页面响应超时！");
                clearInterval(timer);
                options.ajaxOptions.error && options.ajaxOptions.error('', 'error', {status: 302});
            }
        }, 10);
    }

    window.addEventListener('message', function (e) {
        if (typeof e.data != "string") {
            return;
        }
        let msg = parseMsg(e.data);
        if (msg.type == "ready") {
            console.log("-------跨域连接成功~\\(≧▽≦)/~，开始处理跨域请求");
            shelter.isSpyReady = true;
            return;
        }
        if (msg.shelterName != shelter.name + sessionCode) return;
        let res = msg.data;
        if (msg.type) {
            switch (msg.type) {
                case 'ajaxSuccess':
                    options.ajaxOptions.success && options.ajaxOptions.success(res.data, res.status);
                    break;
                case 'ajaxError':
                    options.ajaxOptions.error && options.ajaxOptions.error(res.err);
                    break;
                default:
                    break;
            }
        }
    });

    // 构造iframe代理
    shelterList.forEach(function (data) {
        if (data.src == options.crossOriginSrc) {
            shelterName = data.name;
            shelter = data;
        }
    });
    if (!shelterName) {
        let proxyElem = document.createElement('iframe');
        proxyElem.src = options.crossOriginSrc;
        proxyElem.style.display = "none";
        shelterName = "_spyShelter_" + count + '_';
        proxyElem.name = shelterName;
        document.body.appendChild(proxyElem);
        shelter = {
            name: shelterName,
            src: options.crossOriginSrc
        };
        shelterList.push(shelter);
        console.log("-------跨域代理[" + options.crossOriginSrc + "]连接中...");
        proxyElem.onload = function () {
            transfer('ajax', options.ajaxOptions);
        };
        proxyElem.error = function () {
            options.ajaxOptions.error && options.ajaxOptions.error('', 'error', {status: 404});
        };

    }
    else {
        console.log("-------使用现有跨域代理[" + options.crossOriginSrc + "]");
        transfer('ajax', options.ajaxOptions);
    }
    // transfer('ajax', options.ajaxOptions);
}

// module.exports = AjaxAgency;
export default AjaxAgency;
